import type { ECommunityRole } from '~/entities/container/community/interfaces/community'
import { fromCommunityRoletoD6SW } from '~/entities/container/community/interfaces/community'

import { getMembers } from '~/features-shared/member/api/members-list'
import { useTaggable } from '~/features-shared/tags/composables/taggable'

interface FetchTagsOptions {
  search: string
  filter: ECommunityRole | ''
  threadId: string
  refine: string[]
}

const communityMemberTagSingleton = (() => {
  const taggable = useTaggable({})

  const actions = {
    // Can be factorized
    async fetchTags(opts: FetchTagsOptions) {
      const getRefine = (role: ECommunityRole): string => {
        return `f/ds6w_47_ds6w_58_who_47_ds6w_58_role/xsd:string/${fromCommunityRoletoD6SW(role)}`
      }

      let refine: string[] = []
      if (opts.filter)
        refine = [...refine, getRefine(opts.filter)]
      if (opts.refine)
        refine = [...refine, ...opts.refine]

      const response = await getMembers({
        community_id: opts.threadId,
        ...(opts.search && { query: opts.search }),
        ...(refine.length && { refine }),
      })

      taggable.fetchTagsSeparately?.(async () => ({
        groups: response.groups,
        hits: response.hits,
        total: response.total,
      }))
    },
  }

  return {
    tags: taggable.tags,
    tagsWithSubjectURIData: taggable.tagsWithSubjectURIData,
    tagsWithoutSubjectURIData: taggable.tagsWithoutSubjectURIData,

    fetchTags: actions.fetchTags,
  }
})()

export const useCommunityMemberTag = () => communityMemberTagSingleton
